import request from '@/utils/request'

/**
 * 获取商品列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码
 * @param {Number} params.page_size - 每页条数
 * @param {Number} params.status - 商品状态（-1=全部，0=下架，1=上架）
 * @param {String} params.keyword - 搜索关键词
 */
export function getProductList(params) {
  return request({
    url: '/fuyou/iccid/recharge/admin/products/list',
    method: 'post',
    data: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      status: params.status !== undefined ? params.status : -1,
      keyword: params.keyword
    }
  })
}

/**
 * 创建商品
 * @param {Object} data - 商品数据
 * @param {String} data.product_code - 商品编码（必填，唯一）
 * @param {String} data.product_name - 商品名称（必填）
 * @param {Number} data.price - 商品价格（必填）
 * @param {String} data.description - 商品描述（可选）
 * @param {Number} data.commission_rate - 默认分佣比例（可选，默认10）
 * @param {Number} data.status - 状态（可选，0=下架，1=上架，默认1）
 * @param {String} data.merchant_code - 商户号（可选，来自数据字典 FYPAY 的 dict_value）
 * @param {String} data.merchant_name - 商户名称（可选，来自数据字典 FYPAY 的 dict_label）
 */
export function createProduct(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/products/create',
    method: 'post',
    data: {
      product_code: data.product_code,
      product_name: data.product_name,
      price: data.price,
      description: data.description || '',
      commission_rate: data.commission_rate || 10,
      status: data.status !== undefined ? data.status : 1,
      merchant_code: data.merchant_code || '',
      merchant_name: data.merchant_name || ''
    }
  })
}

/**
 * 更新商品
 * @param {Object} data - 商品数据
 * @param {Number} data.id - 商品ID（必填）
 * @param {String} data.product_name - 商品名称（可选）
 * @param {Number} data.price - 商品价格（可选）
 * @param {String} data.description - 商品描述（可选）
 * @param {String} data.product_type - 商品类型（可选）
 * @param {Number} data.sort - 排序值（可选）
 * @param {String} data.merchant_code - 商户号（可选，来自数据字典 FYPAY 的 dict_value）
 * @param {String} data.merchant_name - 商户名称（可选，来自数据字典 FYPAY 的 dict_label）
 */
export function updateProduct(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/products/update',
    method: 'post',
    data: {
      id: data.id,
      product_name: data.product_name,
      price: data.price,
      description: data.description,
      product_type: data.product_type,
      sort: data.sort,
      merchant_code: data.merchant_code,
      merchant_name: data.merchant_name
    }
  })
}

/**
 * 更新商品状态
 * @param {Object} data - 状态数据
 * @param {Number} data.id - 商品ID（必填）
 * @param {Number} data.status - 状态（必填，0=下架，1=上架）
 */
export function updateProductStatus(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/products/update-status',
    method: 'post',
    data: {
      id: data.id,
      status: data.status
    }
  })
}
